import React from 'react'

import { Modal } from '@driftt/tide-modal'

import { FirstExperienceContent } from './FirstExperienceContent'
import type { FirstExperienceModalProps } from './FirstExperienceModal.types'
import { useFirstExperienceProperties } from './useFirstExperienceProperties.hook'

/**
 * FirstExperienceModal is a component that will only appear the first time a user views the feature
 * Modal will not appear if user hasDissmissed[ELEMENT_NAME] attribute or user was created after featureCreatedDate
 *
 * @param {string} propertyName Name of attribute to patch to user properties. Follows "hasDissmissed[ELEMENT_NAME]" notation
 * @param {Date} featureCreatedDate Date feature is released
 * @param {string} steps Array with steps for the modal, each step must contain a Image (<img /> component), Header (string), and Description (string)
 */

export const FirstExperienceModal = ({
  propertyName,
  featureCreatedDate,
  steps,
}: FirstExperienceModalProps) => {
  const { patchProperty, shouldShowFirstExperience } =
    useFirstExperienceProperties(propertyName, featureCreatedDate)

  return (
    <Modal
      open={shouldShowFirstExperience}
      onClose={() => patchProperty()}
      size="large"
      status="marketable-moment"
    >
      <FirstExperienceContent steps={steps} />
    </Modal>
  )
}
